import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/storeAuth';

const INTERNAL_DOMAINS = ['@enhanced.ai', '@upoutsourcing.com'];

type Props = {
  children: React.ReactNode;
};

const hasInternalDomain = (email: string): boolean => {
  const normalized = email.toLowerCase();
  return INTERNAL_DOMAINS.some(domain => normalized.endsWith(domain));
};

const InternalStaffRoute: React.FC<Props> = ({ children }) => {
  const user = useAuthStore(state => state.user);

  if (!user) {
    return <Navigate to='/login' replace />;
  }

  const isAdmin = user.role === 'admin';
  const isInternal = user.email ? hasInternalDomain(user.email) : false;

  if (!isAdmin && !isInternal) {
    return <Navigate to='/' replace />;
  }

  return <>{children}</>;
};

export default InternalStaffRoute;
